import React, { useState, useEffect } from 'react';
import {
  Box,
  Alert,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
} from '@mui/material';
import axios from 'axios';
import { formatDate } from '../utils/dateFormat';

const SMSTours = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadTours();
  }, []);

  const loadTours = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/sms/tours', {
        params: { limit: 100 },
      });
      setTours(response.data);
    } catch (err) {
      setError('Failed to load SMS tours');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (tour) => {
    if (tour.sms_failed > 0) return 'error';
    if (tour.sms_sent === tour.mobile_numbers_found && tour.mobile_numbers_found > 0) return 'success';
    if (tour.sms_sent > 0) return 'warning';
    return 'default';
  };

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Tour Name</TableCell>
                <TableCell>Date & Time</TableCell>
                <TableCell>Total Participants</TableCell>
                <TableCell>Mobile Numbers Found</TableCell>
                <TableCell>SMS Sent</TableCell>
                <TableCell>SMS Failed</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tours.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography color="text.secondary">
                      No tours found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                tours.map((tour) => (
                  <TableRow key={tour.id}>
                    <TableCell>{tour.tour_name}</TableCell>
                    <TableCell>
                      {tour.send_time ? formatDate(tour.send_time) : `${tour.tour_date} at ${tour.tour_time}`}
                    </TableCell>
                    <TableCell>{tour.total_participants}</TableCell>
                    <TableCell>{tour.mobile_numbers_found}</TableCell>
                    <TableCell>
                      <Chip
                        label={tour.sms_sent}
                        color="success"
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      {tour.sms_failed > 0 ? (
                        <Chip
                          label={tour.sms_failed}
                          color="error"
                          size="small"
                        />
                      ) : (
                        <Typography variant="body2">0</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          tour.sms_sent === tour.mobile_numbers_found && tour.mobile_numbers_found > 0
                            ? 'Complete'
                            : tour.sms_sent > 0
                            ? 'Partial'
                            : 'Pending'
                        }
                        color={getStatusColor(tour)}
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default SMSTours;

